export const BILLING_SUMMARY_GROUP_BY = [
  {
    label: 'None',
    title: 'None',
    value: null
  },
  {
    label: 'Case Manager',
    title: 'Case Manager',
    value: 'caseManager'
  },
  {
    label: 'Group',
    title: 'Group',
    value: 'group'
  },
  {
    label: 'Provider',
    title: 'Provider',
    value: 'provider'
  },
  {
    label: 'Organization',
    title: 'Organization',
    value: 'organization'
  },
  {
    label: 'Primary insurance',
    title: 'Primary insurance',
    value: 'insurance'
  }
]

export const BILLING_SUMMARY_MONTHS = [
  {
    title: 'Jan',
    dataIndex: '01'
  },
  {
    title: 'Feb',
    dataIndex: '02'
  },
  {
    title: 'March',
    dataIndex: '03'
  },
  {
    title: 'April',
    dataIndex: '04'
  },
  {
    title: 'May',
    dataIndex: '05'
  },
  {
    title: 'June',
    dataIndex: '06'
  },
  {
    title: 'July',
    dataIndex: '07'
  },
  {
    title: 'Aug',
    dataIndex: '08'
  },
  {
    title: 'Sept',
    dataIndex: '09'
  },
  {
    title: 'Oct',
    dataIndex: '10'
  },
  {
    title: 'Nov',
    dataIndex: '11'
  },
  {
    title: 'Dec',
    dataIndex: '12'
  }
]
